import React from "react";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useNavigate } from "react-router";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { MenuItem, Select } from "@mui/material";
const ActionButton = (props) => {
  const navigate = useNavigate();
  const {
    goToDetailScreen,
    item,
    isViewIcon = false,
    isEditIcon,
    isRemoveIcon,
    isUpdateIcon,
    RemoveItem,
    handleStatusChange,
    tab,
  } = props;

  return (
    <>
      {isViewIcon ? (
        <button
          title="View Data"
          className="btn text-success px-2 fs-3 ps-0 border-0"
          style={{ cursor: "pointer" }}
          onClick={(e) => {
            navigate(goToDetailScreen, { state: tab });
          }}
        >
          View Data
          <ArrowForwardIosIcon />
        </button>
      ) : null}
      {isEditIcon ? (
        <button
          title="Edit Data"
          className="border-0 cursor-pointer"
          onClick={(e) => {
            goToDetailScreen(item);
          }}
        >
          <EditIcon />
        </button>
      ) : null}
      {isRemoveIcon ? (
        <button
          title="Remove Data"
          className="btn text-success px-2 fs-3 ps-0 border-0"
          style={{ cursor: "pointer" }}
          onClick={(e) => {
            RemoveItem(item);
          }}
        >
          <DeleteIcon />
        </button>
      ) : null}
      {isUpdateIcon ? (
        <button
          title="Update Status"
          className="btn text-success  border-0"
          style={{ cursor: "pointer" }}
        >
          <Select
            sx={{ borderRadius: "100px" }}
            id="status"
            name="status"
            value=""
            onChange={(e) => {
              handleStatusChange(item, e.target.value);
            }}
          >
            {item?.is_active === false && (
              <MenuItem value={true}>Active</MenuItem>
            )}
            {item?.is_active === true && (
              <MenuItem value={false}>Inactive</MenuItem>
            )}
          </Select>
        </button>
      ) : null}
    </>
  );
};
export default ActionButton;
